var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_vm._m(0),_c('div',{staticClass:"form-container"},[_vm._m(1),_vm._t("content")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":require("@/assets/images/image-auth.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":require("@/assets/images/logo-red.png")}})])
}]

export { render, staticRenderFns }